import React from "react";
import DatePicker from "react-datepicker";
import calender from "../../images/common/calender.png";
import greycalender from "../../images/common/greycalender.png";
import '../../scss/reusables/calender.scss';
import "react-datepicker/dist/react-datepicker.css";

const Calender = (props) => {
    const { minDate, maxDate, startdate, label, HandleDate, HandleLabel, disablefromto, disableto } = props;
    
    const ExampleCustomInput =  React.forwardRef(({ value, onClick }, ref) => (
        <div className={disablefromto ? "grey calender-container" : disableto ? "grey calender-container" : "calender-container" } onClick={onClick} ref={ref} >
            <div className="calender-input-box">
                {value}
            </div>
            <img src={disablefromto ? greycalender : disableto ? greycalender : calender} alt=""></img>
        </div>
    ));
    return (
        <>
        <DatePicker 
            selected={startdate} 
            onChange={(date) => {HandleDate(date);HandleLabel(date);}} 
            customInput={<ExampleCustomInput />}
            minDate={minDate}
            maxDate={maxDate}
            useWeekdaysShort={true}
            disabledKeyboardNavigation
            fixedHeight
            value={label}
        />  
        </> 
  );
};
export default Calender